import { atom } from 'jotai';

export const sidebarSearchKeywordAtom = atom<string>('');
